import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO35 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK003-5.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO35
